export default "__VITE_ASSET__00964c11__"